document.addEventListener("DOMContentLoaded", () => {
  const timelines = document.querySelectorAll(".c-timeline");

  if (!timelines.length) return;

  const rafScroll = (() => {
    let ticking = false;

    function update() {
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const windowMiddle = windowHeight / 3;

      timelines.forEach((timeline) => {
        const progression = timeline.querySelector(".js-timeline-progression");
        const items = timeline.querySelectorAll(".js-timeline-item");

        if (!progression || !items.length) return;

        const rect = timeline.getBoundingClientRect();
        const timelineHeight = rect.height;
        const distanceFromMiddle = windowMiddle - rect.top;

        if (rect.top < windowMiddle && rect.bottom > 0) {
          const progress = Math.min(
            1,
            Math.max(0, distanceFromMiddle / timelineHeight)
          );

          progression.style.setProperty("--timeline", `${progress * 100}%`);

          const progressionRect = progression.getBoundingClientRect();
          const barTopPosition = progressionRect.top;
          const barCurrentHeight = progress * progressionRect.height;
          const barCurrentBottom = barTopPosition + barCurrentHeight;

          items.forEach((item) => {
            const date = item.querySelector(".js-timeline-date");
            if (!date) return;

            const itemRect = item.getBoundingClientRect();
            const itemCenter = itemRect.top + (itemRect.height / 2);

            if (barCurrentBottom >= itemCenter) {
              date.classList.add("c-timeline__date--blue");
            } else {
              date.classList.remove("c-timeline__date--blue");
            }
          });

        } else if (rect.bottom <= 0) {
          progression.style.setProperty("--timeline", "100%");
          items.forEach((item) => {
            const date = item.querySelector(".js-timeline-date");
            if (date) {
              date.classList.add("c-timeline__date--blue");
            }
          });
        } else {
          progression.style.setProperty("--timeline", "0%");
          items.forEach((item) => {
            const date = item.querySelector(".js-timeline-date");
            if (date) {
              date.classList.remove("c-timeline__date--blue");
            }
          });
        }
      });

      ticking = false;
    }

    return () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };
  })();

  window.addEventListener("scroll", rafScroll, { passive: true });
  window.addEventListener("resize", rafScroll);

  rafScroll();
});
